var VFSMain = require("network_places/VFSMain");
var NavHistoryManager = require("navigation/BrowserNavigationHistory");

$(document).on("mobileinit", function() {
    new NavHistoryManager();
});

VFSMain(true);
